export default "__VITE_PUBLIC_ASSET__635a97c4__"